import { ParamMap } from '@angular/router';

import { ReportsRouteTypeEnum } from '../../../Common/Reports/enums/reports-route-type.enum';
import { ReportsRouteValueMapModel } from './reports-route-value-map.model';

export class ReportsRouteModel {
    type: ReportsRouteTypeEnum;
    reportsRouteValueMap?: ReportsRouteValueMapModel;
    queryParamMap?: ParamMap;

    constructor(type: ReportsRouteTypeEnum, value?: ReportsRouteValueMapModel, queryParamMap?: ParamMap) {
        this.type = type;
        this.reportsRouteValueMap = value;
        this.queryParamMap = queryParamMap;
    }
}
